import Api from "./Api";
import Csrf from "./Csrf";

export default { 
	
  async index() {
    await Csrf.getCookie();

    return Api.get("/prices");
  },	

  async indexGuesthouse(guesthouse_id) {
    await Csrf.getCookie();

    return Api.get("/prices/guesthouse/" + guesthouse_id);
  },	
	
  async show(id) {
    await Csrf.getCookie();

    return Api.get("/prices/"+id);
  },	

  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/prices/"+id);
  },	
	
  async store(data) {
    await Csrf.getCookie();

    return Api.post("/prices",data);
  },	
  
  async getPrices(data) {
    await Csrf.getCookie();
  
    return Api.post("/get-prices",data);  
  },

  async getGuestCategoryPrices(data){
    await Csrf.getCookie();

    return Api.post("/get-guest-category-prices",data);
  }
	,
  async update(data) {
    await Csrf.getCookie();

    return Api.post("/prices/update",data);
  },	
	
};